import { mapStore } from "../store";

export function clearSelectedMarker() {
  if (!mapStore.selectedMarker) return;

  mapStore.selectedMarker.setMap(null);
  mapStore.selectedMarker = null;
}
